import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Utils} from '../../../../common/services/Utils';
import {CommonService} from '../../../shared/services/common.service';
import {AuthService} from '../../../../common/services/auth.service';
import {Principal} from '../../../../common/services/principal';
import {CommonMainLayoutComponent} from '../common-main-layout/common-main-layout.component';
import {RestorePasswordModalComponent} from '../restore-password/modal/restore-password-modal.component';
import {MatDialog} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {Enroll} from '../../../../common/models/enroll';
import {CollegeInfoService} from '../../services/college-info.service';
import {Language} from '../../../../common/models/language';
import {EnrollApplicationDialogComponent} from './enroll-application-dialog/enroll-application-dialog.component';
import {EnrollApplicationService} from '../../services/enroll-application.service';

@Component({
  selector: 'app-enroll-enter',
  templateUrl: './enroll-enter.component.html',
  styleUrls: ['./enroll-enter.component.scss']
})
export class EnrollEnterComponent implements OnInit {

  canRegister: boolean = false;
  colleges: College[];
  userModel = new Enroll(0, '', '');
  private formSubmitAttempt: boolean;
  showRestore = false;
  showUserApplicationLink = false;
  langID: string;

  constructor(private dialog: MatDialog,
              private utils: Utils,
              private translateService: TranslateService,
              private commonService: CommonService,
              private _authService: AuthService,
              public _principal: Principal,
              private collegeInfoService: CollegeInfoService,
              private commonMainLayoutComponent: CommonMainLayoutComponent,
              private _enrollApplicationService: EnrollApplicationService) {
    this.langID = Language.getCurrentLanguage().code;
  }

  ngOnInit() {
    if (!this._principal.isLoggedInFromBackend()) {
      this.commonMainLayoutComponent.initializeAdminPanelLink(true);
    }
    this.showRestore = true;
    // this.commonService.showRestorePassword().subscribe(data => {
    //   this.showRestore = data;
    // });
    this.commonService.showUserApplicationLink().subscribe(data => {
      this.showUserApplicationLink = data;
    });
    this.collegeInfoService.getColleges(this.langID).subscribe(
      response => {
        this.colleges = response['dictionaryCollege'];
      },
      err => {
        console.log(err);
      }
    );
    this._enrollApplicationService.canRegister().subscribe(value => {
      this.canRegister = value;
    });
  }

  collegeSelected() {
    if (this.userModel.college) {
      console.log('this.userModel.college', this.userModel.college);
      this.utils.blockStart();
      this.collegeInfoService.getCollegeInfoByID(this.userModel.college, this.translateService.currentLang).subscribe(value => {
        const collegeInfoMap: any = value['collegeInfoMap'];

        if (!collegeInfoMap['receive_enroll_on_pem']) {
          window.location.href = collegeInfoMap['college_url'];
        }
        this.utils.blockStop();
      });
    }
  }

  getSelectedCollegeName(): any {
    let college: College;
    college = this.colleges.find(value => {
      return (value.id === this.userModel.college);
    });
    return college.name;
  }

  onSubmit(valid) {
    if (!valid) {
      return;
    }
    this.formSubmitAttempt = true;
    this._authService.loginEnroll(this.userModel);
  }

  restorePassword(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(RestorePasswordModalComponent, {
      width: '900px',
      height: '350px',
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.utils.notifySuccess(this.translateService.instant('saved'), null);
      }
    });
  }

  register(): void {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(EnrollApplicationDialogComponent, {
      width: '1100px',
      height: '750px',
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.utils.notifySuccess(this.translateService.instant('saved'), null);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/enroll-enter/enroll-enter.component.ts